import{classAdderBuilder as a}from"../../common/dist/classadder/classAdderBuilder.js";var d=a({class:"mdc-text-field__affix mdc-text-field__affix--suffix",tag:"span"});export{d as default};
//# sourceMappingURL=Suffix.js.map
